// extracted by mini-css-extract-plugin
export default {"container":"TextListComponent_container__dXI4t","textRow":"TextListComponent_textRow__V28d+"};